import { View } from "react-native";

import { Icon } from "@/components/ui/icon";
import { Text } from "@/components/ui/text";
import { getInitials } from "@/lib/getInitials";
import { cn } from "@/lib/utils";

type UserAvatarProps = {
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    className?: string;
    size?: "sm" | "md" | "xs";
};

/**
 * Circular avatar showing name initials, or a user icon when none are available.
 */
export function UserAvatar({
    firstName,
    lastName,
    name,
    className,
    size = "md",
}: UserAvatarProps) {
    const initials = getInitials(firstName, lastName, name);
    const isSmall = size === "sm";
    const isTiny = size === "xs";

    return (
        <View
            accessibilityElementsHidden
            importantForAccessibility="no-hide-descendants"
            className={cn(
                "shrink-0 items-center justify-center rounded-full bg-primary",
                isSmall ? "size-10" : isTiny ? "size-8" : "size-14",
                className,
            )}
        >
            {initials ? (
                <Text
                    variant="label"
                    className={cn(
                        "text-primary-foreground",
                        isTiny ? "text-xs" : "text-sm",
                    )}
                >
                    {initials}
                </Text>
            ) : (
                <Icon
                    name="user"
                    iconStyle="solid"
                    size={isSmall ? 16 : isTiny ? 12 : 20}
                    className="text-primary-foreground"
                />
            )}
        </View>
    );
}
